import {
  TOGGLE_DRAWER,
  CLOSE_DRAWER
} from './types';


const initialState = {
  open: null,
  // sets if the drawer is shown above (false) or below (true) the toolbar
  clipped: true,
  // sets if the drawer is CSS positioned as 'fixed'
  fixed: false,
  // sets if the drawer remains visible all the time (true) or not (false)
  // En fait, permanent doit toujours être à false sinon, la sidebar
  // est toujours visible même lorsque le viewport est en xs...
  // On le met à false, ainsi ce comportement "permanent" est neutralisé.
  permanent: false,
  // sets the drawer to the mini variant, showing only icons, of itself (true)
  // or showing the full drawer (false)
  mini: false,
  // Sets the designated mobile breakpoint
  // mobileBreakPoint: 800,
  // width: 300,
};

const getters = {
  getSidebarState: state => state.open,
};

const actions = {
  toggleDrawer({ commit }) {
    console.log('TOGGLE_DRAWER');
    console.log('------avt------');
    console.log(this.state.open);
    commit(TOGGLE_DRAWER);
    console.log('------apr------');
    console.log(this.state.open);
  },
  closeDrawer({ commit }) {
    console.log('CLOSE_DRAWER');
    commit(CLOSE_DRAWER);

  }
};

const mutations = {
  [TOGGLE_DRAWER](state) {
    if (state.permanent) {
      state.permanent = !state.permanent;
      state.clipped = true;
      state.open = !state.open;
    }
    else {
      state.open = !state.open;
    }
  },
  [CLOSE_DRAWER](state, val) {
    /* Nécessaire comme setter sur v-model lorsque
       sur petit écran (overlay)
       Voir notes sur component SideBar.vue
    */
    state.open = val
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
